import React from 'react';
import { Bed, Bath, Square } from 'lucide-react';
import { Link } from 'react-router-dom';
interface PropertyCardProps {
  id: string;
  image: string;
  price: string;
  address: string;
  city: string;
  beds: number;
  baths: number;
  sqft: string;
  isNew?: boolean;
}
export function PropertyCard({
  id,
  image,
  price,
  address,
  city,
  beds,
  baths,
  sqft,
  isNew
}: PropertyCardProps) {
  return <Link to={`/property/${id}`} className="cursor-pointer flex flex-col gap-4 group focus:outline-none focus-visible:ring-2 focus-visible:ring-charcoal-900 focus-visible:ring-offset-4 rounded-2xl" data-id="element-75">
      <div className="relative aspect-[4/3] overflow-hidden rounded-2xl bg-stone-100" data-id="element-76">
        <img src={image} alt={address} className="w-full h-full object-cover" data-id="element-77" />
        {isNew && <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold tracking-wider uppercase text-charcoal-900" data-id="element-78">
            Just Listed
          </div>}
        <div className="absolute bottom-4 right-4 bg-charcoal-900/80 backdrop-blur-md px-4 py-2 rounded-full text-white font-medium" data-id="element-79">
          {price}
        </div>
      </div>

      <div className="flex flex-col gap-1 px-1" data-id="element-80">
        <h3 className="text-lg font-semibold text-charcoal-900 truncate" data-id="element-81">
          {address}
        </h3>
        <p className="text-charcoal-500 text-sm" data-id="element-82">{city}</p>

        <div className="flex items-center gap-4 mt-3 pt-3 border-t border-stone-100 text-charcoal-600 text-sm" data-id="element-83">
          <div className="flex items-center gap-1.5" data-id="element-84">
            <Bed size={16} className="text-charcoal-400" data-id="element-85" />
            <span data-id="element-86">{beds} Beds</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-87">
            <Bath size={16} className="text-charcoal-400" data-id="element-88" />
            <span data-id="element-89">{baths} Baths</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-90">
            <Square size={16} className="text-charcoal-400" data-id="element-91" />
            <span data-id="element-92">{sqft} sqft</span>
          </div>
        </div>
      </div>
    </Link>;
}